import "core-js/modules/es6.string.small";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDocumentsById } from '~/services/editorial';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import GlobalArticleCard from '~/components/molecules/Editorial/Global/GlobalArticleCard.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';

var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

var COLORS = {
  grey: 'btn-dark',
  white: 'btn-white',
  transparent: 'btn-transparent'
};
export default {
  name: 'ArticleList',
  components: {
    GlobalTitle: GlobalTitle,
    SimpleParagraph: SimpleParagraph,
    GlobalArticleCard: GlobalArticleCard
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      currentArticles: this.payload.items.map(function (_ref7) {
        var article = _ref7.article;
        return {
          slug: article.slug,
          image: {
            small: '',
            medium: '',
            large: ''
          },
          tags: article.tags,
          date: '',
          title: '',
          description: [],
          readingTime: 0,
          difficulty: 0
        };
      })
    };
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6;

      return {
        backgroundColor: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? _ref6.background_color : _ref6 : _ref6) || '#E6DAD3',
        title: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? (_ref5 = _ref5.title) != null ? _ref5[0] : _ref5 : _ref5 : _ref5) || {},
        subtitle: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? (_ref4 = _ref4.subtitle) != null ? _ref4[0] : _ref4 : _ref4 : _ref4) || {},
        paragraph: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.paragraph : _ref3 : _ref3) || [],
        readMore: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.read_more : _ref2 : _ref2) === 'Yes',
        textColor: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.text_color : _ref : _ref) || '',
        button: {
          text: this.payload.primary.button_text,
          color: COLORS[this.payload.primary.button_color],
          url: this.payload.primary.button_url ? this.payload.primary.button_url.url : '',
          tracking: {
            data: {
              event_category: this.payload.primary.event_category1,
              event_action: this.payload.primary.event_action1,
              event_label: this.payload.primary.event_label1
            }
          }
        }
      };
    },
    lessThanTwoArticles: function lessThanTwoArticles() {
      return this.currentArticles.length < 2;
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var ids, _ref9, results;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ids = this.payload.items.map(function (_ref8) {
                var article = _ref8.article;
                return article.id;
              });
              _context.next = 3;
              return fetchDocumentsById(this.$store, ids);

            case 3:
              _ref9 = _context.sent;
              results = _ref9.results;
              this.currentArticles = results.map(function (_ref10) {
                var article = _ref10.data,
                    tags = _ref10.tags;
                return {
                  tags: tags,
                  slug: article.slug,
                  image: {
                    small: formatPrismicImage(article.image.small.url, ['w_375,ar_4:3,c_fill']) || EMPTY_PIXEL,
                    medium: formatPrismicImage(article.image.medium.url, ['w_375,dpr_2,ar_3:4,c_fill']) || EMPTY_PIXEL,
                    large: formatPrismicImage(article.image.large.url, ['w_1440,ar_3:4,c_fill']) || EMPTY_PIXEL
                  },
                  date: article.date,
                  title: article.main_title[0].text || '',
                  description: article.description,
                  readingTime: article.reading_time || 0,
                  difficulty: article.difficulty || 0
                };
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }()
};